import { useStudioTranslate } from '@repo/studio-config/studio-config-context'
import { AlertOnlineDotsOnlineBlinking } from '@repo/studio-online-presence/alert-online-dots'
import { useUsersOnlineCount } from '@repo/studio-online-presence/hooks/use-users-online-count'

/** @figma https://www.figma.com/design/Jky2GUhAX9y6ajLFg921fb/AI-Marketing-Studio?node-id=4028-69662 */
export function NavigationUsersOnline() {
  const usersOnlineCount = useUsersOnlineCount()
  const t = useStudioTranslate()

  return (
    <span className="flex min-w-0 items-center gap-1.5 studio-typography-14 text-theme_semantic_surface_ui_foreground-color-regular">
      <span className="flex size-4 shrink-0 items-center justify-center">
        <AlertOnlineDotsOnlineBlinking />
      </span>
      <span className="truncate">
        {usersOnlineCount === undefined
          ? t('studio.flow.online.loading')
          : t('studio.flow.online', { count: usersOnlineCount })}
      </span>
    </span>
  )
}
